import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider, CssBaseline } from '@mui/material'
import { AuthProvider } from './hooks/useAuth'
import { InstanceProvider } from './contexts/InstanceContext'
import App from './App'
import theme from './theme'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <InstanceProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </InstanceProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
